import { format } from 'date-fns';
import { TIME_INPUT_FORMAT } from '../../../../constants';
import { parseTimeOnlyValue } from './parseTimeOnlyValue';

export const formatStaticTime = (value: string | null): string | null => {
  if (!value) return null;

  const time = parseTimeOnlyValue(value);
  if (!time) return value;

  try {
    return format(time, TIME_INPUT_FORMAT);
  } catch {
    return value;
  }
};
